import React from 'react';
import { Link } from 'react-router-dom';

/**
 * 公开站的状态页（404 / 空站 / 卡片不存在 / 加载失败）。样式见 style.css「状态页」段，自带明暗两套 token，
 * 不依赖 .markdown-body 作用域里的 github 变量。
 * actions: [{ label, to }]（站内路由，需在 Router 内）| [{ label, href }]（整页跳转）| [{ label, onClick }]；primary 为主按钮。
 */
export const STATUS = {
    siteMissing: {
        icon: '🧭',
        code: '404',
        title: '这个站点不存在，或还没有开放',
        description: '请检查地址是否拼写正确。如果你是站长，可以在写作后台的「设置 → 站点信息」里开启公开站。',
    },
    pageMissing: {
        icon: '🗺️',
        code: '404',
        title: '页面走丢了',
        description: '你访问的页面不存在，可能是链接有误，或者内容已经被移走。',
    },
    cardMissing: {
        icon: '🔍',
        title: '这张卡片不存在或未公开',
        description: '它可能已被删除、改回了草稿，或者链接有误。',
    },
    emptySite: {
        icon: '🌱',
        title: '这里还没有公开的笔记',
        description: '站长发布第一张卡片后，内容就会出现在这里。',
    },
    loadError: {
        icon: '☁️',
        title: '加载失败',
        description: '网络好像不太稳定，请稍后再试。',
    },
}

function Action({ action }) {
    const cls = 'status-view-btn' + (action.primary ? ' primary' : '')
    if (action.to) return <Link className={cls} to={action.to}>{action.label}</Link>
    if (action.href) return <a className={cls} href={action.href}>{action.label}</a>
    return <button type='button' className={cls} onClick={action.onClick}>{action.label}</button>
}

function StatusView({ kind, icon, code, title, description, actions = [], compact = false }) {
    const preset = (kind && STATUS[kind]) || {}
    const view = {
        icon: icon ?? preset.icon,
        code: code ?? preset.code,
        title: title ?? preset.title,
        description: description ?? preset.description,
    }
    return (
        <section className={'status-view' + (compact ? ' compact' : '')} role='status'>
            {view.icon && <div className='status-view-icon' aria-hidden='true'>{view.icon}</div>}
            {view.code && <div className='status-view-code'>{view.code}</div>}
            {view.title && <h1 className='status-view-title'>{view.title}</h1>}
            {view.description && <p className='status-view-desc'>{view.description}</p>}
            {actions.length > 0 && (
                <div className='status-view-actions'>
                    {actions.map((a) => <Action key={a.label} action={a} />)}
                </div>
            )}
        </section>
    )
}

export default StatusView;
